module.exports = __webpack_public_path__ + "img/qq_1.7a1ce823.svg";